import { Company } from '@mirai-kids-monte/core/src/constants/Company';
import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const appearsOnRadio202311: BlogMetaData = {
  title: 'ラジオ出演のお知らせ',
  description: `代表の${Company.CEO}がラジオに出演し、モンテッソーリ教育の魅力を語ってきました！`,
  thumbnailUrl: 'https://www.radicro.com/news/wp-content/uploads/2023/05/minatomachidayo-top980350px.png',
  filePath: buildBlogFilePath('2023_11-appears-on-radio'),
  category: BLOG_CATEGORY.NEWS,
};
